<div class="order_success_popup" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel"
    tabindex="-1">
    <div class="popup_main">
        <div class="close_btn" (click)="closePopup(null)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M15 1L1 15M15 15L1 1" stroke="black" stroke-width="1.5" stroke-linecap="round" />
            </svg>
        </div>
        <svg class="svg_icon" xmlns="http://www.w3.org/2000/svg" width="248" height="205" viewBox="0 0 248 205"
            fill="none">
            <rect x="224" y="156" width="14" height="14" rx="7" fill="url(#paint0_linear_312_1844)" />
            <rect y="95" width="14" height="14" rx="7" fill="url(#paint1_linear_312_1844)" />
            <rect x="96" width="10" height="10" rx="5" fill="url(#paint2_linear_312_1844)" />
            <rect x="238" y="93" width="10" height="10" rx="5" fill="url(#paint3_linear_312_1844)" />
            <rect x="210" y="119" width="6" height="6" rx="3" fill="url(#paint4_linear_312_1844)" />
            <rect x="240" y="119" width="3" height="3" rx="1.5" fill="url(#paint5_linear_312_1844)" />
            <rect x="204" y="170" width="3" height="3" rx="1.5" fill="url(#paint6_linear_312_1844)" />
            <rect x="102" y="187" width="3" height="3" rx="1.5" fill="url(#paint7_linear_312_1844)" />
            <rect x="100" y="202" width="3" height="3" rx="1.5" fill="url(#paint8_linear_312_1844)" />
            <rect x="149" y="190" width="3" height="3" rx="1.5" fill="url(#paint9_linear_312_1844)" />
            <rect x="188" y="147" width="3" height="3" rx="1.5" fill="url(#paint10_linear_312_1844)" />
            <rect x="84" y="166" width="3" height="3" rx="1.5" fill="url(#paint11_linear_312_1844)" />
            <rect x="42" y="154" width="3" height="3" rx="1.5" fill="url(#paint12_linear_312_1844)" />
            <rect x="39" y="119" width="3" height="3" rx="1.5" fill="url(#paint13_linear_312_1844)" />
            <rect x="21" y="81" width="3" height="3" rx="1.5" fill="url(#paint14_linear_312_1844)" />
            <rect x="49" y="64" width="3" height="3" rx="1.5" fill="url(#paint15_linear_312_1844)" />
            <rect x="96" y="34" width="3" height="3" rx="1.5" fill="url(#paint16_linear_312_1844)" />
            <rect x="126" y="14" width="3" height="3" rx="1.5" fill="url(#paint17_linear_312_1844)" />
            <rect x="194" y="41" width="3" height="3" rx="1.5" fill="url(#paint18_linear_312_1844)" />
            <rect x="228" y="50" width="3" height="3" rx="1.5" fill="url(#paint19_linear_312_1844)" />
            <rect x="65" y="184" width="3" height="3" rx="1.5" fill="url(#paint20_linear_312_1844)" />
            <rect x="71" y="49" width="100" height="100" rx="50" fill="url(#paint21_linear_312_1844)" />
            <path d="M98 99.726C104.445 106.313 112.29 114.332 112.29 114.332C112.29 114.332 132.771 93.574 143.202 83"
                stroke="white" stroke-width="6" stroke-miterlimit="10" />
            <defs>
                <linearGradient id="paint0_linear_312_1844" x1="237.592" y1="164.458" x2="224" y2="160.842"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint1_linear_312_1844" x1="13.5917" y1="103.458" x2="-2.70998e-07" y2="99.8417"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint2_linear_312_1844" x1="105.708" y1="6.04167" x2="96" y2="3.45833"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint3_linear_312_1844" x1="247.708" y1="99.0417" x2="238" y2="96.4583"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint4_linear_312_1844" x1="215.825" y1="122.625" x2="210" y2="121.075"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint5_linear_312_1844" x1="242.912" y1="120.812" x2="240" y2="120.037"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint6_linear_312_1844" x1="206.912" y1="171.812" x2="204" y2="171.037"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint7_linear_312_1844" x1="104.912" y1="188.812" x2="102" y2="188.037"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint8_linear_312_1844" x1="102.912" y1="203.812" x2="100" y2="203.037"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint9_linear_312_1844" x1="151.912" y1="191.812" x2="149" y2="191.037"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint10_linear_312_1844" x1="190.912" y1="148.812" x2="188" y2="148.037"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint11_linear_312_1844" x1="86.9125" y1="167.812" x2="84" y2="167.037"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint12_linear_312_1844" x1="44.9125" y1="155.812" x2="42" y2="155.037"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint13_linear_312_1844" x1="41.9125" y1="120.812" x2="39" y2="120.037"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint14_linear_312_1844" x1="23.9125" y1="82.8125" x2="21" y2="82.0375"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint15_linear_312_1844" x1="51.9125" y1="65.8125" x2="49" y2="65.0375"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint16_linear_312_1844" x1="98.9125" y1="35.8125" x2="96" y2="35.0375"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint17_linear_312_1844" x1="128.912" y1="15.8125" x2="126" y2="15.0375"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint18_linear_312_1844" x1="196.912" y1="42.8125" x2="194" y2="42.0375"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint19_linear_312_1844" x1="230.912" y1="51.8125" x2="228" y2="51.0375"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint20_linear_312_1844" x1="67.9125" y1="185.812" x2="65" y2="185.037"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
                <linearGradient id="paint21_linear_312_1844" x1="168.083" y1="109.417" x2="71" y2="83.5833"
                    gradientUnits="userSpaceOnUse">
                    <stop offset="0.022525" stop-color="#48A6A7" />
                    <stop offset="1" stop-color="#74D8D9" />
                </linearGradient>
            </defs>
        </svg>
        <div class="middle_text">
            <p class="main_text">Your order has been placed successfully.</p>
            <p class="sub_text">We will assign an advisor to you for further processing.</p>
        </div>
        <p class="sub_text">You can track the status from order history.</p>
        <button (click)="closePopup('history')">View Order History</button>
    </div>
</div>